import Image from 'next/image';
import { MecProduct } from '@adapters/bigcommerce/types/product';
import Tag from '_components/UI/Tag';
import { resolveCompareImageSrc } from '@utils/comparison/resolveCompareImageSrc';

import styles from '../ProductCompareTable.module.scss';

interface ProductColumnProps {
  name: string;
  product?: MecProduct | null;
  imageUrl?: string;
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  ariaLabel?: string;
  isFirst?: boolean;
}

const ProductColumn = ({
  name,
  product,
  imageUrl,
  href,
  onClick,
  ariaLabel,
  isFirst,
}: ProductColumnProps) => {
  const tags = (
    product?.productTags?.filter((tag) => tag !== null) ?? []
  ).slice(0, 1);

  const src = resolveCompareImageSrc(imageUrl, product);

  const media = src ? (
    <Image
      src={src}
      alt={name}
      fill
      objectFit="contain"
      // Mirrors .imageWrapper width in ProductCompareTable.module.scss
      // (rem(187px), rem(304px) at respond(md)) — keep in sync. rem so it
      // scales with the user's root font size like the CSS does.
      sizes="(min-width: 45rem) 19rem, 11.6875rem"
      className={`${styles.productImage} ${
        isFirst ? styles.firstProductImage : ''
      }`}
    />
  ) : (
    <div className={styles.imagePlaceholder} aria-hidden="true" />
  );

  return (
    <div>
      <div
        className={`${styles.imageWrapper} ${
          isFirst ? styles.firstImageWrapper : ''
        }`}
      >
        {href ? (
          <a
            href={href}
            onClick={onClick}
            className={styles.imageLink}
            aria-label={ariaLabel}
          >
            {media}
          </a>
        ) : (
          media
        )}
        {tags.length > 0 && (
          <div className={styles.imageTag} aria-hidden="true">
            {tags.map((tag) => (
              <Tag key={tag!.name} size="medium" color="gray">
                {tag!.name}
              </Tag>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductColumn;
